import Contact from '../../pages/contact'

const contactRoute = [
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  }
]

export default contactRoute



// WEBPACK FOOTER //
// ./src/router/contact/index.js